'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _CaseActivity = require('./CaseActivity');

var _CaseActivity2 = _interopRequireDefault(_CaseActivity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DeletedCaseDocument = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(DeletedCaseDocument, _Component);

  function DeletedCaseDocument() {
    _classCallCheck(this, DeletedCaseDocument);

    return _possibleConstructorReturn(this, (DeletedCaseDocument.__proto__ || Object.getPrototypeOf(DeletedCaseDocument)).apply(this, arguments));
  }

  _createClass(DeletedCaseDocument, [{
    key: 'render',
    value: function render() {
      var activity = this.props.activity;


      var body = 'Deleted case document \'' + activity.case_document_name + '\'';

      return _react2.default.createElement(_CaseActivity2.default, _extends({ activity_body: body, dot: 'small' }, this.props));
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return DeletedCaseDocument;
}(_react.Component), _class2.propTypes = {
  activity: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired
  }).isRequired
}, _temp)) || _class) || _class;

var _default = DeletedCaseDocument;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DeletedCaseDocument, 'DeletedCaseDocument', '/app/src/components/common-activities/DeletedCaseDocument.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-activities/DeletedCaseDocument.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL2NvbW1vbi1hY3Rpdml0aWVzL0RlbGV0ZWRDYXNlRG9jdW1lbnQuanMiXSwibmFtZXMiOlsiRGVsZXRlZENhc2VEb2N1bWVudCIsImF1dG9CaW5kTWV0aG9kcyIsIm9ic2VydmVyIiwiYWN0aXZpdHkiLCJwcm9wcyIsImJvZHkiLCJjYXNlX2RvY3VtZW50X25hbWUiLCJDb21wb25lbnQiLCJwcm9wVHlwZXMiLCJQcm9wVHlwZXMiLCJzaGFwZSIsImlkIiwic3RyaW5nIiwiaXNSZXF1aXJlZCIsInR5cGUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7QUFDQTs7QUFDQTs7OztBQUVBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFJTUEsbUIsT0FGTEMsZ0MsZUFDQUMsbUI7Ozs7Ozs7Ozs7OzZCQUdXO0FBQUEsVUFDQUMsUUFEQSxHQUNhLEtBQUtDLEtBRGxCLENBQ0FELFFBREE7OztBQUdSLFVBQU1FLG9DQUFpQ0YsU0FBU0csa0JBQTFDLE9BQU47O0FBRUEsYUFDRSw4QkFBQyxzQkFBRCxhQUFjLGVBQWVELElBQTdCLEVBQW1DLEtBQUksT0FBdkMsSUFBbUQsS0FBS0QsS0FBeEQsRUFERjtBQUdEOzs7Ozs7Ozs7OztFQVYrQkcsZ0IsV0FZekJDLFMsR0FBWTtBQUNqQkwsWUFBVU0sb0JBQVVDLEtBQVYsQ0FBZ0I7QUFDeEJDLFFBQUlGLG9CQUFVRyxNQUFWLENBQWlCQyxVQURHO0FBRXhCQyxVQUFNTCxvQkFBVUcsTUFBVixDQUFpQkM7QUFGQyxHQUFoQixFQUdQQTtBQUpjLEM7O2VBUU5iLG1COzs7Ozs7Ozs7OzswQkFwQlRBLG1CIiwiZmlsZSI6IkRlbGV0ZWRDYXNlRG9jdW1lbnQuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBDb21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IHsgb2JzZXJ2ZXIgfSBmcm9tICdtb2J4LXJlYWN0JztcbmltcG9ydCBhdXRvQmluZE1ldGhvZHMgZnJvbSAnY2xhc3MtYXV0b2JpbmQtZGVjb3JhdG9yJztcblxuaW1wb3J0IENhc2VBY3Rpdml0eSBmcm9tICcuL0Nhc2VBY3Rpdml0eSc7XG5cbkBhdXRvQmluZE1ldGhvZHNcbkBvYnNlcnZlclxuY2xhc3MgRGVsZXRlZENhc2VEb2N1bWVudCBleHRlbmRzIENvbXBvbmVudCB7XG5cbiAgcmVuZGVyICgpIHtcbiAgICBjb25zdCB7IGFjdGl2aXR5IH0gPSB0aGlzLnByb3BzO1xuXG4gICAgY29uc3QgYm9keSA9IGBEZWxldGVkIGNhc2UgZG9jdW1lbnQgJyR7YWN0aXZpdHkuY2FzZV9kb2N1bWVudF9uYW1lfSdgO1xuXG4gICAgcmV0dXJuIChcbiAgICAgIDxDYXNlQWN0aXZpdHkgYWN0aXZpdHlfYm9keT17Ym9keX0gZG90PSdzbWFsbCcgey4uLnRoaXMucHJvcHN9IC8+XG4gICAgKTtcbiAgfVxuXG4gIHN0YXRpYyBwcm9wVHlwZXMgPSB7XG4gICAgYWN0aXZpdHk6IFByb3BUeXBlcy5zaGFwZSh7XG4gICAgICBpZDogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICAgICAgdHlwZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICAgIH0pLmlzUmVxdWlyZWQsXG4gIH07XG59XG5cbmV4cG9ydCBkZWZhdWx0IERlbGV0ZWRDYXNlRG9jdW1lbnQ7XG4iXX0=